import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: "#4F46E5", contrastText: "#FFF" }, // Premium Indigo
    secondary: { main: "#06B6D4", contrastText: "#FFF" }, // Cyan accent
    background: { 
      default: "#FFFFFF", 
      paper: "#FFFFFF" 
    },
    text: {
      primary: "#111827",
      secondary: "#4B5563"
    },
    divider: "rgba(0, 0, 0, 0.06)"
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    button: { textTransform: 'none', fontWeight: 600 }
  },
  shape: { borderRadius: 16 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(0, 0, 0, 0.04)',
          boxShadow: '0 10px 40px -10px rgba(0,0,0,0.08)',
          backdropFilter: 'blur(20px)',
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '8px 24px',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
            '& fieldset': { borderColor: 'rgba(0, 0, 0, 0.08)' },
            '&:hover fieldset': { borderColor: 'rgba(0, 0, 0, 0.15)' },
            '&.Mui-focused fieldset': { borderColor: '#4F46E5', borderWidth: '2px' },
          }
        }
      }
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
